var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "animated fadeOut",
        mode: "out-in"
      }
    },
    [
      _vm.isVisible
        ? _c(
            "wrapper-tag",
            {
              directives: [
                {
                  name: "top-border",
                  rawName: "v-top-border:color",
                  value: _vm.topBorderColor,
                  expression: "topBorderColor",
                  arg: "color"
                }
              ],
              staticClass: "box",
              class: _vm.classes,
              style: _vm.boxStyle,
              attrs: { tag: _vm.tag, id: _vm.guid }
            },
            [
              _vm.hasHeaderSlot
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "bg",
                          rawName: "v-bg:palette",
                          value: _vm.headerBackground,
                          expression: "headerBackground",
                          arg: "palette"
                        }
                      ],
                      staticClass: "box-header"
                    },
                    [
                      _vm.closable
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "corner-btn close",
                              style: { background: _vm.headerBackground },
                              attrs: {
                                slot: "title",
                                flat: "",
                                title: _vm.$t("global.close")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.close($event)
                                }
                              },
                              slot: "title"
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("close")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resizable
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "corner-btn resize",
                              style: { background: _vm.headerBackground },
                              attrs: {
                                slot: "title",
                                flat: "",
                                title: _vm.maximized
                                  ? _vm.$t("box.minimize")
                                  : _vm.$t("box.maximize")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.resize(false)
                                }
                              },
                              slot: "title"
                            },
                            [
                              _c("v-icon", { attrs: { color: "dark" } }, [
                                _vm._v("open_in_new")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("header")
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "box-content",
                  class: { maximized: _vm.maximized }
                },
                [
                  _vm.hasContentSlot ? _vm._t("content") : _vm._e(),
                  _vm._v(" "),
                  _vm.hasDefaultSlot ? _vm._t("default") : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.hasFooterSlot
                ? _c(
                    "div",
                    { staticClass: "box-footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3edcc572", { render: render, staticRenderFns: staticRenderFns })
  }
}